import { SkeletonListItems } from '@/components/List';
import OrdersListItem from './OrdersListItem';

export { OrdersListItem };

export type OrdersListProps = {
  isFetchingData?: boolean;
  variant?: 'card' | 'flat';
  className?: string;
  orderIds: number[];
  onOpen?: () => void;
};

export default function OrdersList({
  isFetchingData,
  variant = 'card',
  className,
  orderIds,
  onOpen,
}: OrdersListProps) {
  return (
    <div className={className}>
      {isFetchingData ? (
        <SkeletonListItems />
      ) : (
        orderIds.map((id) => (
          <OrdersListItem
            key={id}
            orderId={id}
            variant={variant}
            onOpen={onOpen}
          />
        ))
      )}
    </div>
  );
}
